module.exports = __webpack_public_path__ + "img/3291220_s.3f8fbea0.jpg";